import { FC } from "react";
import styled from "styled-components";
import { useHotelPage } from "~/applications/OfferSearch/Api/useHotelPage";
import { HotelWithOffers } from "~/applications/OfferSearch/Domain/HotelWithOffers";
import { Offer } from "~/applications/OfferSearch/Domain/Offer";
import { PinPointKing } from "~/components/Map/PinPoint";
import MediaCarousel from "~/components/MediaCarousel";
import StayRequest from "~/core/StayRequest";
import { AVAILABLE_LOCALES } from "~/core/locale";
import mediaQueries from "~/guidelines/Theme/mediaQueries";
import HotelRoomList from "./HotelRoomList";

interface HotelCardProps {
  hotel: HotelWithOffers;
  destinationSeoSlug: string;
  selectedStayRequest: StayRequest;
  soldOutOffers?: Array<Offer>;
  locale: AVAILABLE_LOCALES;
  destinationId: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
  width: 100%;
  box-shadow:
    0px 3px 5px 0px rgba(104, 85, 39, 0.05),
    0px 9px 16px 0px rgba(104, 85, 39, 0.07);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.xl()} {
    flex-direction: row;
  }
`;

const MediaCarouselWrapper = styled.div`
  width: 100%;

  ${mediaQueries.xl()} {
    width: 60%;
  }
`;

const HotelCard: FC<HotelCardProps> = ({
  hotel,
  destinationSeoSlug,
  selectedStayRequest,
  soldOutOffers,
  locale,
  destinationId,
}) => {
  const { hotelPage } = useHotelPage({
    destinationId,
    hotelSlug: hotel.slug,
    locale,
  });

  const gallery = hotelPage?.loge.gallery
    ? hotelPage.loge.gallery.map((img) => ({
        asset: {
          url: img.asset.url,
        },
        caption: img.caption,
      }))
    : [];

  const mapData = {
    latitude: hotel.address.coordinate.latitude,
    longitude: hotel.address.coordinate.longitude,
    zoom: 15,
    marker: {
      label: hotel.name,
      longitude: hotel.address.coordinate.longitude,
      latitude: hotel.address.coordinate.latitude,
      kind: PinPointKing.PinkPin,
      zoom: 15,
    },
  };

  return (
    <Container>
      <ContentWrapper>
        <MediaCarouselWrapper>
          <MediaCarousel
            gallery={gallery}
            mapData={mapData}
            mobileHeight="300px"
            customBorderRadius={{
              desktop: {
                topRight: "0",
                bottomRight: "0",
              },
              mobile: {
                bottomLeft: "0",
                bottomRight: "0",
              },
            }}
          />
        </MediaCarouselWrapper>

        <HotelRoomList
          hotel={hotel}
          selectedStayRequest={selectedStayRequest}
          destinationSlug={destinationSeoSlug}
          soldOutOffers={soldOutOffers}
        />
      </ContentWrapper>
    </Container>
  );
};

export default HotelCard;
